import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

/**
 * Hook to check if the badge verification redesign feature is enabled.
 *
 * @returns Whether the badge verification redesign is enabled
 */
export function useIsBadgeVerificationRedesignEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.BADGE_VERIFICATION_REDESIGN, {
    defaultValue: false,
  });
}
